// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"4f7a4e4f","732":"657b03e6","977":"f87379db"}[chunkId] + ".chunk.js";
};